import React from 'react';
import { Cell, Row } from 'react-table';

interface Props {
    cell: Cell<TrqkSong>;
    row: Row<TrqkSong>;
}

export const LinkCell = ({ cell, row }: Props): JSX.Element | string => {
    const { value } = cell;
    const { index } = row;

    if (value === null) {
        return 'None';
    }

    return (
        <a href={value} target="_blank" rel="noopener noreferrer">
            {`Statement ${index + 1}`}
        </a>
    );
};
